import { render, staticRenderFns } from "./AlertMessageComponent.vue?vue&type=template&id=a70e140a"
import script from "./AlertMessageComponent.vue?vue&type=script&lang=js"
export * from "./AlertMessageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports